(() => {
  if (window.rinseKindTheme) return;
  window.rinseKindTheme = true;
  const config = JSON.parse(document.getElementById('ThemeConfig').textContent);
  const q = (selector, root = document) => root.querySelector(selector);
  let cartBusy = false;
  let variantRequest;
  let opener;
  const live = message => { q('#StatusMessage').textContent = message; };
  function errorIn(element, message) {
    const box = q('[data-product-error], [data-cart-error]', element);
    if (box) { box.textContent = message; box.hidden = false; }
    live(message);
  }
  function openCart(source = document.activeElement) {
    const drawer = q('#CartDrawer');
    if (!drawer) { location.assign(config.cart); return; }
    if (!drawer.open) { opener = source; drawer.showModal(); }
    document.body.classList.add('drawer-open');
    q('[data-close-cart]', drawer)?.focus();
  }
  function busyCart(busy) {
    cartBusy = busy;
    document.body.classList.toggle('cart-busy', busy);
    document.querySelectorAll('[data-product-form] button[name="add"], [data-sticky-purchase] button, [data-cart-form] button, [data-cart-quantity]').forEach(input => {
      if (busy) { input.dataset.previouslyDisabled = String(input.disabled); input.disabled = true; }
      else if (input.dataset.previouslyDisabled !== undefined) { input.disabled = input.dataset.previouslyDisabled === 'true'; delete input.dataset.previouslyDisabled; }
    });
  }
  const sectionIds = () => ['cart-drawer', q('[data-cart-page]')?.dataset.sectionId].filter(Boolean);
  function renderCart(sections) {
    const drawerWasOpen = q('#CartDrawer')?.open;
    for (const id of sectionIds()) {
      if (!sections?.[id]) throw new Error(config.cartCheck);
      const doc = new DOMParser().parseFromString(sections[id], 'text/html');
      const incoming = doc.getElementById(`shopify-section-${id}`);
      const current = document.getElementById(`shopify-section-${id}`);
      if (!incoming || !current) throw new Error(config.cartCheck);
      if (id === 'cart-drawer') {
        q('.drawer-content', current).replaceChildren(...q('.drawer-content', incoming).childNodes);
      } else current.replaceWith(incoming);
    }
    const count = q('[data-cart-state]')?.dataset.itemCount || '0';
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = count; });
    if (drawerWasOpen) q('[data-close-cart]')?.focus();
  }
  async function requestCart(path, body) {
    const response = await fetch(`${path}.js`, { method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body:JSON.stringify({...body, sections:sectionIds(), sections_url:location.pathname}) });
    let data;
    try { data = await response.json(); } catch { throw new Error(config.cartCheck); }
    if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : config.error);
    return data;
  }
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-product-form]');
    if (!form || (event.submitter && event.submitter.name !== 'add')) return;
    event.preventDefault();
    if (cartBusy || variantRequest) return;
    if (!form.reportValidity()) return;
    const submitter = event.submitter || q('button[name="add"]', form);
    const id = Number(new FormData(form).get('id'));
    const quantity = Number(new FormData(form).get('quantity'));
    if (!Number.isInteger(quantity) || quantity < 1) return;
    q('[data-product-error]',form).hidden = true;
    busyCart(true);
    try {
      const data = await requestCart(config.add,{items:[{id,quantity}]});
      try { renderCart(data.sections); openCart(submitter); live(config.added); }
      catch { location.assign(config.cart); }
    } catch (error) { errorIn(form,error.message); }
    finally { busyCart(false); }
  });
  async function changeLine(key, quantity, origin) {
    if (cartBusy || !Number.isInteger(quantity) || quantity < 0) return;
    busyCart(true);
    try {
      const data = await requestCart(config.change,{id:key,quantity});
      renderCart(data.sections);
      live(config.updated);
    } catch (error) { errorIn(origin,error.message); }
    finally { busyCart(false); }
  }
  async function selectVariant(url, updateHistory = true) {
    const current = q('[data-product-section]');
    if (!current || cartBusy) return;
    variantRequest?.abort();
    const controller = new AbortController();
    variantRequest = controller;
    const quantity = q('[data-quantity]',current)?.value || '1';
    const parsed = new URL(url,location.origin);
    const renderUrl = new URL(location.href);
    renderUrl.pathname = parsed.pathname;
    if (parsed.searchParams.has('variant')) renderUrl.searchParams.set('variant',parsed.searchParams.get('variant'));
    else renderUrl.searchParams.delete('variant');
    renderUrl.searchParams.set('section_id',current.dataset.sectionId);
    current.setAttribute('aria-busy','true');
    current.classList.add('variant-loading');
    try {
      const response = await fetch(renderUrl,{signal:controller.signal});
      if (!response.ok) throw new Error(config.error);
      const html = await response.text();
      if (controller.signal.aborted) return;
      const doc = new DOMParser().parseFromString(html,'text/html');
      const replacement = q('[data-product-section]',doc);
      if (!replacement) throw new Error(config.error);
      q('[data-quantity]',replacement).value = quantity;
      current.replaceWith(replacement);
      renderUrl.searchParams.delete('section_id');
      if (updateHistory) history.pushState({},'',renderUrl.pathname+renderUrl.search);
      q('[aria-current="true"][data-variant-link]',replacement)?.focus({preventScroll:true});
      if (window.Shopify?.PaymentButton) window.Shopify.PaymentButton.init();
      initSticky();
      initGallery();
      syncQuantity(replacement);
    } catch(error) {
      if (error.name !== 'AbortError') errorIn(current,error.message);
    } finally {
      if (variantRequest === controller) { variantRequest = undefined; current.removeAttribute('aria-busy'); current.classList.remove('variant-loading'); }
    }
  }
  document.addEventListener('click',event => {
    const target = event.target;
    const open = target.closest('[data-open-cart]');
    if (open) { event.preventDefault(); openCart(open); return; }
    if (target.closest('[data-close-cart]')) { q('#CartDrawer').close(); return; }
    if (target === q('#CartDrawer')) { const rect=target.getBoundingClientRect(); if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)target.close(); }
    const remove = target.closest('[data-cart-remove]');
    if (remove) { event.preventDefault(); changeLine(remove.dataset.key,0,remove.closest('[data-cart-form]')); return; }
    const variant = target.closest('[data-variant-link]');
    if (variant && !event.metaKey && !event.ctrlKey && !event.shiftKey) { event.preventDefault(); selectVariant(variant.href); return; }
    const thumbnail = target.closest('[data-gallery-target]');
    if (thumbnail) { event.preventDefault(); const image=document.getElementById(thumbnail.dataset.galleryTarget); const gallery=q('[data-gallery]'); if(image&&gallery) gallery.scrollTo({left:image.offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}); }
    const direction = target.closest('[data-gallery-direction]');
    if(direction) { const gallery=q('[data-gallery]'); if(gallery) { const slides=[...gallery.children]; const index=Math.round(gallery.scrollLeft/gallery.clientWidth); const next=(index+Number(direction.dataset.galleryDirection)+slides.length)%slides.length; gallery.scrollTo({left:slides[next].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}); } }
  });
  function syncQuantity(section) {
    const label=q('[data-sticky-quantity]',section);const quantity=q('[data-quantity]',section)?.value;
    if(label)label.textContent=quantity>1?` × ${quantity}`:'';
  }
  document.addEventListener('input',event => { if(event.target.matches('[data-quantity]'))syncQuantity(event.target.closest('[data-product-section]')); });
  document.addEventListener('change',event => { if(event.target.matches('[data-cart-quantity]'))changeLine(event.target.dataset.key,Number(event.target.value),event.target.closest('[data-cart-form]')); });
  document.addEventListener('close',event => { if(event.target.id==='CartDrawer'){document.body.classList.remove('drawer-open');opener?.focus?.();} },true);
  document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.mobile-nav[open]').forEach(el=>el.open=false);});
  window.addEventListener('popstate',()=>selectVariant(location.href,false));
  let observer;
  function initSticky() {
    observer?.disconnect();
    const section=q('[data-product-section]');const main=q('.purchase-row',section||document);const sticky=q('[data-sticky-purchase]');
    document.body.classList.toggle('has-product',Boolean(section));
    if(!main||!sticky)return;
    observer=new IntersectionObserver(entries=>{sticky.classList.toggle('is-visible',!entries[0].isIntersecting);},{threshold:0});
    observer.observe(main);
  }
  function initGallery() {
    const gallery=q('[data-gallery]');
    if(!gallery||gallery.dataset.initialized)return;
    gallery.dataset.initialized='true';
    const update=()=>{
      const slides=[...gallery.children]; const index=Math.max(0,Math.min(slides.length-1,Math.round(gallery.scrollLeft/gallery.clientWidth)));
      const count=q('[data-gallery-count]'); if(count)count.textContent=`${String(index+1).padStart(2,'0')} / ${slides.length}`;
      const full=q('[data-gallery-full]'); const current=slides[index];
      if(full&&current) { const source=current.dataset.fullImage||q('img',current)?.src; full.hidden=!source; if(source)full.href=source; }
      document.querySelectorAll('[data-gallery-target]').forEach(link=>{if(link.dataset.galleryTarget===slides[index]?.id)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');});
    };
    gallery.addEventListener('scroll',update,{passive:true});
    gallery.addEventListener('keydown',event=>{if(event.target!==gallery||!['ArrowLeft','ArrowRight'].includes(event.key))return;event.preventDefault();q(`[data-gallery-direction="${event.key==='ArrowLeft'?-1:1}"]`)?.click();});
    update();
  }
  document.addEventListener('shopify:section:load',()=>{initSticky();initGallery();});
  initSticky();
  initGallery();
})();
